<template>
  <div class="footer-gray">
    <div class="desc-text" style=" width: 1100px;margin: 40px auto;margin-top: 40px; margin-bottom: 10px;font-family: '微软雅黑';">
      {{ $finalData.CompanyFootName }}
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030602005118"
        style="display: inline-block; text-decoration: none; margin-left: 5px"
      >
        <img src="@/assets/img/beian-icon.png" />
        <span style="color: #D3E7E9;font-family: '微软雅黑';"> 粤公网安备 44030602005118号 </span>
      </a>
    </div>
    <!-- <div class="desc-text">
      {{ $finalData.CompanyFootCode }}
    </div> -->
    <!-- <img
      src="@/assets/img/footer-logo.png"
      width="auto"
      style="height: 50px; margin-top: 20px"
    /> -->
    <a
      href="https://szcert.ebs.org.cn/e5fb5231-5aa6-4a71-ad4f-88095ad8aa1d"
      target="_blank"
    >
      <img
        src="https://szcert.ebs.org.cn/Images/newGovIcon.gif"
        title="深圳市市场监督管理局企业主体身份公示"
        alt="深圳市市场监督管理局企业主体身份公示"
        width="112"
        height="40"
        border="0"
        style="border-width: 0px; border: hidden; border: none"
      />
    </a>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style  lang="stylus" scoped>
.footer-gray {
  padding-top: 10px;
  padding-bottom: 50px;
  text-align: center;
  background-color:#0E919B;
  width: 1364px;
  margin: auto;
}

.desc-text {
  font-size: 16px;
  line-height: 20px;
  /*color: #545454;*/
  color: #D3E7E9;
}
</style>



// WEBPACK FOOTER //
// src/pages/frame/FooterGray.vue